import { DropDown, DropDownItem } from '@wajeez-web/components/ui';
import { DotsVerticalIcon } from '@heroicons/react/solid';
import React from 'react';

export type WajeezRowProps = {
  title?: string | JSX.Element;
  headerActions?: DropDownItem[];
  endSideComponents?: React.ReactNode[];
  paddingStyle?: string;
  widthStyleTitle?: string;
};

function WajeezRow({
  title,
  headerActions,
  endSideComponents,
  paddingStyle = 'py-6 px-4',
  widthStyleTitle,
}: WajeezRowProps) {
  return (
    <div
      className={`${paddingStyle} justify-between space-s-4 flex align-middle items-center`}
    >
      <div className={`${widthStyleTitle} text-textPrimary my-auto`}>
        {title}
      </div>
      <div className="flex space-s-1 h-full align-middle">
        {endSideComponents &&
          endSideComponents.map((c, i) => (
            <React.Fragment key={i + ''}>{c}</React.Fragment>
          ))}
        {headerActions && headerActions.length > 0 ? (
          <DropDown
            Icon={DotsVerticalIcon}
            buttonType="text"
            bg="ring-color"
            shape="circle"
            color="textSecondary"
            name="card header"
            list={headerActions}
          />
        ) : null}
      </div>
    </div>
  );
}

export default WajeezRow;
